module.exports = __webpack_public_path__ + "media/KikiTom.58cf212d.mp3";